module.exports = __webpack_public_path__ + "static/media/20210409_210123_851_IMG_0172.22bae402.jpg";